import CoreComponent from '../../core/CoreComponent.vue';
import Swiper from 'swiper';
import { Keyboard, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
export default {
  extends: CoreComponent,
  mounted() {
    const linkElements = document.querySelectorAll('.cmp-resourcecscontainer__card-buttons');
    linkElements.forEach(link => {
      const alink = link.querySelector('.cmp-button-card-link');
      if (alink != null) {
        alink.addEventListener('click', this.handleLinkClick);
      }
    });
    const bulletButtonAriaLabel = window.Granite?.I18n?.get('cardcontainer.carousel.pagination');
    const resourcesCarousel = this.cmpEl.querySelector('.cmp-resourcecscontainer-carousel__resources');
    if (resourcesCarousel) {
      var resourceSwiper = new Swiper(resourcesCarousel, {
        slidesPerView: 1,
        spaceBetween: 16,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        modules: [Keyboard, Navigation, Pagination],
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        pagination: {
          el: this.cmpEl.querySelector('.cmp-resourcecscontainer--carousel-pagination'),
          clickable: true,
          bulletElement: 'button',
          renderBullet: function () {
            return `<button class="dot swiper-pagination-bullet" aria-label="${bulletButtonAriaLabel}"><span class="invisible">${bulletButtonAriaLabel}</span></button>`;
          }
        },
        navigation: {
          nextEl: null,
          prevEl: null
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 3
          },
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2
          }
        }
      });
      const paginationContainers = this.cmpEl.querySelectorAll('.cmp-resourcecscontainer--carousel-pagination');
      paginationContainers.forEach(paginationContainer => {
        const paginationBullets = paginationContainer.querySelectorAll('.swiper-pagination-bullet');
        const bulletCount = paginationBullets.length;
        const nextButton = document.createElement('div');
        nextButton.classList.add('swiper-button-next');
        const prevButton = document.createElement('div');
        prevButton.classList.add('swiper-button-prev');

        //check if closet parent swiper-button-prev is there
        var swiperInitializedElement = "";
        var prevButtonElement = "";
        var nextButtonElement = "";
        const observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
            if (paginationContainer.classList.contains('swiper-pagination-lock')) {
              prevButton.style.display = 'none';
              nextButton.style.display = 'none';
            } else {
              prevButton.style.display = 'flex';
              nextButton.style.display = 'flex';
              swiperInitializedElement = paginationContainer.closest('.swiper-initialized');
              prevButtonElement = swiperInitializedElement.querySelector('.swiper-button-prev');
              nextButtonElement = swiperInitializedElement.querySelector('.swiper-button-next');
              if (prevButtonElement == null && nextButtonElement == null) {
                paginationContainer.parentNode.insertBefore(prevButton, paginationContainer);
                paginationContainer.parentNode.insertBefore(nextButton, paginationContainer);
                resourceSwiper.params.navigation.prevEl = prevButton;
                resourceSwiper.params.navigation.nextEl = nextButton;
                resourceSwiper.navigation.init();
                resourceSwiper.navigation.update();
              }
            }
          });
        });
        const config = {
          attributes: true,
          childList: true,
          subtree: true
        };
        observer.observe(paginationContainer, config);
        window.addEventListener('resize', () => {
          //  MutationObserver
          observer.disconnect();
          observer.observe(paginationContainer, config);
          if (paginationContainer.classList.contains('swiper-pagination-lock')) {
            prevButton.style.display = 'none';
            nextButton.style.display = 'none';
          } else {
            prevButton.style.display = 'flex';
            nextButton.style.display = 'flex';
            swiperInitializedElement = paginationContainer.closest('.swiper-initialized');
            prevButtonElement = swiperInitializedElement.querySelector('.swiper-button-prev');
            nextButtonElement = swiperInitializedElement.querySelector('.swiper-button-next');
            if (prevButtonElement == null && nextButtonElement == null) {
              paginationContainer.parentNode.insertBefore(prevButton, paginationContainer);
              paginationContainer.parentNode.insertBefore(nextButton, paginationContainer);
              resourceSwiper.params.navigation.prevEl = prevButton;
              resourceSwiper.params.navigation.nextEl = nextButton;
              resourceSwiper.navigation.init();
              resourceSwiper.navigation.update();
            }
          }
        });
        if (bulletCount >= 2) {
          prevButton.style.display = 'flex';
          nextButton.style.display = 'flex';
          swiperInitializedElement = paginationContainer.closest('.swiper-initialized');
          prevButtonElement = swiperInitializedElement.querySelector('.swiper-button-prev');
          nextButtonElement = swiperInitializedElement.querySelector('.swiper-button-next');
          if (prevButtonElement == null && nextButtonElement == null) {
            paginationContainer.parentNode.insertBefore(prevButton, paginationContainer);
            paginationContainer.parentNode.insertBefore(nextButton, paginationContainer);
            resourceSwiper.params.navigation.prevEl = prevButton;
            resourceSwiper.params.navigation.nextEl = nextButton;
            resourceSwiper.navigation.init();
            resourceSwiper.navigation.update();
          }
        }
      });

      // Add click event to navigate to the first CTA link
      const cardImages = this.cmpEl.querySelectorAll('.card-image');
      cardImages.forEach(image => {
        const card = image.closest('.cmp-resourcecscontainer__card');
        const firstCtaElement = card?.querySelector('.cmp-button-card-link');
        if (firstCtaElement) {
          image.style.cursor = 'pointer';
          image.addEventListener('click', () => {
            firstCtaElement.click();
          });
        }
      });
    }
  }
};